import CustomModal from 'components/global/CustomModal'
import React, { useState } from 'react'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import CreateRollCall from './content/CreateRollCall'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import SelectAttendees from './content/SelectAttendees'

const RollCallModal: React.FC = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { rollCallModalOpen, setRollCallModalOpen, setCheckInOutModalOpen } =
    eventAttendanceStore(store => ({
      rollCallModalOpen: store.rollCallModalOpen,
      setRollCallModalOpen: store.setRollCallModalOpen,
      setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    }))
  const [current, setCurrent] = useState(0)
  const [payload, setPayload] = useState()
  const closeModal = () => {
    setRollCallModalOpen(false)
    setCheckInOutModalOpen(true)
  }

  const handleBack = () => {
    if (current === 0) {
      closeModal()
    } else {
      setCurrent(current - 1)
    }
  }

  return (
    <>
      <CustomModal
        openModal={rollCallModalOpen}
        closeModal={closeModal}
        title="Create Roll-call"
        width={1200}
        footer={
          <CustomModalFooter
            multibutton={true}
            btnText={current === 0 ? 'Cancel,Next' : 'Back,Submit'}
            btnAlignment="justify-between"
            onSubmit={handleSubmit}
            closeModal={handleBack}
          />
        }
      >
        {current === 0 && (
          <CreateRollCall
            form={form}
            setPayload={setPayload}
            setCurrent={setCurrent}
          />
        )}
        {current === 1 && <SelectAttendees payload={payload} form={form} />}
      </CustomModal>
    </>
  )
}

export default RollCallModal
